// extracted by mini-css-extract-plugin
export default {"card":"EmissionsSection_card__Bp+6h"};